export default __webpack_public_path__ + "static/media/priority-high.8fd18848.svg";